import ToKhaiPage from "./ToKhaiPage";

export default ToKhaiPage